import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const RefreshLeftIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-labelledby="titleId"
      aria-label="Refresh left icon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.70812 7.40413C4.08964 7.24282 4.52968 7.42134 4.69099 7.80285L6.00735 10.9162L9.09972 9.60875C9.48124 9.44745 9.92128 9.62596 10.0826 10.0074C10.2439 10.389 10.0654 10.829 9.68386 10.9903L5.9007 12.5898C5.51918 12.7512 5.07914 12.5726 4.91783 12.1911L3.3094 8.38699C3.14809 8.00548 3.32661 7.56544 3.70812 7.40413Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9149 5.66406C9.46811 5.66406 6.66646 8.40977 6.57984 11.8241C6.56934 12.2381 6.22514 12.5653 5.81106 12.5548C5.39698 12.5443 5.06982 12.2001 5.08032 11.786C5.18759 7.55802 8.65486 4.16406 12.9149 4.16406C17.2392 4.16406 20.7498 7.6747 20.7498 11.9989C20.7498 16.3318 17.2386 19.8338 12.9149 19.8338C10.2344 19.8338 7.87621 18.4922 6.45811 16.4498C6.22187 16.1095 6.30619 15.6422 6.64643 15.406C6.98667 15.1697 7.454 15.254 7.69024 15.5943C8.8411 17.2518 10.7484 18.3338 12.9149 18.3338C16.4113 18.3338 19.2498 15.5022 19.2498 11.9989C19.2498 8.50313 16.4107 5.66406 12.9149 5.66406Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
    </svg>
  );
};

export default RefreshLeftIcon;
